/**
 * @Author   yt.nie
 * @Github   https://github.com/yutang8215
 * @DateTime 2019-06-07
 * @Description [全局配置]
 */

let baseUrl = '';
let devTestToken = '';

if (process.env.NODE_ENV == 'development') {
  /**
   * 开发环境url
   */
  baseUrl = "http://192.168.10.158:20106"; //北疆158
  devTestToken = "7e18dbbbcb5097dbf5cdeb0141392b57"; //自然158

  // baseUrl = "http://ticketbjapi.tjnhm.com"; //北疆线上
  // devTestToken = "2d41a9520f2dcdeb15fd782156617f40"; //自然线上
} else if (process.env.NODE_ENV == 'production') {
  /**
   * 生产环境url
   */
  baseUrl = "http://ticketbjapi.tjnhm.com"; //北疆
}

/**
 * @导出配置
 */
module.exports = {
  // --------------------------------------------------->
  // 以下是共用字段
  // ----------------------
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: '北疆博物院',
  /**
   * @description 网站当前域名
   */
  websiteDomain: 'tjnhm.com',
  /**
   * @description api请求基础路径 - 天津自然博物馆
   */
  baseUrl,
  /**
   * @description 是否使用开发环境测试token
   */
  devTestToken,
  /**
   * @description 动态前缀
   */
  prefix: 'tjnm',
  /**
   * @description username键名
   */
  userNameKey: 'tjnm__username',
  /**
   * @description 访问类型键名，1个人，2团体，3旅行社
   */
  entryTypeKey: 'tjnm__entry_type',

  // --------------------------------------------------->
  // 以下是散客、普通团体用字段
  // ----------------------
  /**
   * @description openid键名
   */
  authIdKey: 'tjnm__auth_id',
  /**
   * @description token键名
   */
  apiTokenKey: 'tjnm__api_token',
  //
  // --------------------------------------------------->
  // 以下是旅行社用字段
  // ---------------
  /**
   * @description username键名
   */
  travelNameKey: 'tjnm__travel_name',
  /**
   * @description token键名
   */
  travelApiTokenKey: 'tjnm__travel_api_token',
}



// WEBPACK FOOTER //
// ./src/config/index.js